import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { displayNewAppointmentFormApiHandler } from 'owa-calendar-addins-helpers';

export const displayNewAppointmentForm = (
    requiredAttendees?: EmailAddressWrapper[],
    optionalAttendees?: EmailAddressWrapper[],
    start?: number,
    end?: number,
    location?: string,
    resources?: string[],
    subject?: string,
    body?: string
) => {
    displayNewAppointmentFormApiHandler(
        'Mail_AddIns',
        undefined /* parentFolderId */,
        requiredAttendees,
        optionalAttendees,
        start,
        end,
        location,
        resources,
        subject,
        body
    );
};
